module.exports = __webpack_public_path__ + "img/img1.13108d0c.svg";